import React from "react";
import { connect} from 'react-redux';
import { withTranslation } from 'react-i18next';
import FullBoardConst from "../constants/full_board.constants";
import ImgIconComp from "./imgcomp";
import { IconPathComp, WbEventHandlerMixins } from "../utils/common";

import { hot } from "react-hot-loader/root";
import debounce from 'lodash/debounce';
import axios from 'axios';
import Header from "./board/header";

const CancelToken = axios.CancelToken;
let cancelRequest = null;
let url = wbConfig.baseUrl + '/board/getFullBoardDetails';

const LoaderComp = function (props) {
	return (<div className="loading-comp"><ImgIconComp id="loadinggif" /></div>);
};
class WsFullBoardComp extends React.Component {
  constructor(props) {
    super(props);
    this.updateBoardFavData = this.updateBoardFavData.bind(this);
    this.delayCallback = debounce(this.handleScroll, 100);
    this.state= {
      loading: false,
      pagination: true
    }
    window.WsFullBoardComp = this;
  }

  componentDidMount() {
    window.addEventListener('scroll', this.delayCallback, false);
    $(document).on("update_board_fav_data", {}, this.updateBoardFavData);
    this._isMounted = true;
  }
  componentWillUnmount(){
    this._isMounted = false;
    window.removeEventListener('scroll', this.delayCallback, false);
    window.WsFullBoardComp = null;
  }

  updateBoardFavData(e, args) {
    const { obj_id, updateStatus, data = {} } = args;
    const { actions } = this.props;
    if (updateStatus == 1) {
      const findItem = data.find(item => item.obj_id === obj_id);
      if (findItem) {
        actions.AddBoardFavData(findItem);
      }
    } else if (updateStatus == 0) {
      actions.DelBoardFavData(data);
    }
  }

handleScroll =()=>{
  const { actions } = this.props;
  this.setState({
    loading: true,
  });
  const pageLimit = 50;
  const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
  const body = document.body;
  const html = document.documentElement;
  const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  const windowBottom = windowHeight + window.pageYOffset + (docHeight/3);
  let query ={};
  let totalCount = this.props.totalCount || 0;
  console.log("totalCount",totalCount);
  
  query.offset = totalCount;
  if (cancelRequest != null) {
    cancelRequest();
  }
  if(totalCount == 0){
    this.setState({
      loading: false
    });
    return false;
  }
  if(windowBottom >= (docHeight)  && this._isMounted && totalCount >= pageLimit && this.state.pagination){
    //Make ajax call and update state
    axios({
      method: "get",
      url,
      cancelToken: new CancelToken(function executor(c) {
        cancelRequest = c;
      }),
      params: query,
      headers: {'X-Requested-With': 'XMLHttpRequest'},
    })
    .then(response => {
      this.setState({
        pagination: false
      });
        if (response.data) {
         // let count = response.data.boardLeftmenuData.workstreams.toalCount;
          actions.UpdateBoardWsData(response.data);
            this.setState({
              loading: false,
              pagination: true
            });
          }
          this.setState({
            loading: false,
            pagination: true
          });
    });
  }
  
} 
  render() {
    const { t } = this.props;
    const fullBoardData = this.props.fullBoard;
    const brdLeftMenuData = fullBoardData.boardLeftmenuData;
    const wsList = brdLeftMenuData.workstreams;
    const readPermission = fullBoardData.readOnlyePermission;
    const readFlag = fullBoardData.readOnlyFeatureFlag;
    const readOnly = {
      readFlag: fullBoardData.readOnlyFeatureFlag,
      isUserReadOnly: fullBoardData.readOnlyePermission === "0"
    }
    return (
      <>
      <div className="fullBoardWrapperDiv">
        <Header readOnly={readOnly} />

        {fullBoardData && (
          <div>
            {fullBoardData.favorites && fullBoardData.favorites.length > 0 && (
              <div className="fullBoardFavWrapper">
                <div className="fullBoardHeading">{t('Favorites')}</div>
                <div className="fullBoardFavTiles">
                  {fullBoardData.favorites.map(it => (
                    <FullBoardFavTile
                      key={it.obj_id}
                      brdDet={it}
                      menuType={it.obj_type}
                      navigate={this.props.navigate}
                    />
                  ))}
                </div>
              </div>
            )}
            {brdLeftMenuData && (
              <div>
                {((typeof brdLeftMenuData.myBoards !== "undefined" &&
                  brdLeftMenuData.myBoards.length > 0) ||
                  (typeof brdLeftMenuData.sharedBoards !== "undefined" &&
                    brdLeftMenuData.sharedBoards.length > 0)) && (
                  <div className="fullBoardNonTeamBoardWrapper" key="mybrd">
                    <div className="fullBoardHeading">{t('Visual Boards')}</div>
                    <div className="fullBoardSmallTiles">
                      {fullBoardData.boardLeftmenuData.myBoards.map(it => (
                        <FullBoardSmallTile
                          key={it.id}
                          brdDet={it}
                          menuType="board"
                          actions={this.props.actions}
                          favList={fullBoardData.favorites}
                          navigate={this.props.navigate}
                        />
                      ))}
                      {fullBoardData.boardLeftmenuData.sharedBoards.map(it => (
                        <FullBoardSmallTile
                          key={it.id}
                          brdDet={it}
                          menuType="board"
                          actions={this.props.actions}
                          favList={fullBoardData.favorites}
                          navigate={this.props.navigate}
                        />
                      ))}
                    </div>
                  </div>
                )}
                {wsList && (
                  <div>
                    {wsList.teams &&
                      Object.keys(wsList.teams).length > 0 &&
                      Object.keys(wsList.teams).map(it => (
                        wsList.teams[it].state != 0 && (
                            <div
                              className="fullBoardWsTeamWrapper"
                              key={`team_${wsList.teams[it].id}`}
                            >
                              <div className="fullBoardHeading">
                                {wsList.teams[it].name}
                              </div>
                              {wsList.teams[it].ws &&
                                Object.keys(wsList.teams[it].ws).length > 0 &&
                                Object.keys(wsList.teams[it].ws).map(
                                  item =>
                                    wsList.teams[it].ws[item].status != "0"  && (
                                      <FullBoardSmallTile
                                        key={`board_teams_${wsList.teams[it].ws[item].id}`}
                                        brdDet={wsList.teams[it].ws[item]}
                                        actions={this.props.actions}
                                        menuType="workstream"
                                        favList={fullBoardData.favorites}
                                        navigate={this.props.navigate}
                                      />
                                    )
                                )}
                            </div>
                          )
                        
                      ))}
                    {wsList.shareWs && Object.keys(wsList.shareWs).length > 0 && (
                      <div className="fullBoardSharedMeWrapper" key="sharedws">
                        <div className="fullBoardHeading">{t('Shared with Me')}</div>
                        {Object.keys(wsList.shareWs).map(it => (
                          <FullBoardSmallTile
                            key={`board_sharews_${it.id}`}
                            brdDet={wsList.shareWs[it]}
                            actions={this.props.actions}
                            menuType="workstream"
                            favList={fullBoardData.favorites}
                            navigate={this.props.navigate}
                          />
                        ))}
                      </div>
                    )}
                    {wsList.retriedWS &&
                      Object.keys(wsList.retriedWS).length > 0 && (
                        <div
                          className="fullBoardArchivedWrapper"
                          key="archivedws"
                        >
                          <div className="fullBoardHeading">{t('Archived')}</div>
                          <div className="fullBoardSmallTiles">
                            {Object.keys(wsList.retriedWS).map(it => (
                              <FullBoardSmallTile
                                key={`board_retriews_${it.id}`}
                                brdDet={wsList.retriedWS[it]}
                                actions={this.props.actions}
                                menuType="workstream"
                                favList={fullBoardData.favorites}
                                navigate={this.props.navigate}
                              />
                            ))}
                          </div>
                        </div>
                      )}
                    {wsList.personal &&
                      Object.keys(wsList.personal).length > 0 && (
                        <div
                          className="fullBoardPersonalWrapper"
                          key="personal"
                        >
                          <div className="fullBoardHeading">{t('Personal')}</div>
                          <div className="fullBoardSmallTiles">
                            {Object.keys(wsList.personal).map(it => (
                              <FullBoardSmallTile
                                key={`board_wslist_${wsList.personal[it].id}`}
                                brdDet={wsList.personal[it]}
                                actions={this.props.actions}
                                menuType="workstream"
                                favList={fullBoardData.favorites}
                                navigate={this.props.navigate}
                              />
                            ))}
                          </div>
                        </div>
                      )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
        {this.state.loading ? 
        <LoaderComp /> :""
        }
      </>
    );
  }
}

class FullBoardSmallTile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clsName: "",
      bgVal: getBgForTile({ theme: this.props.brdDet.theme }),
      pinStatus: getItemPinStatus({
        id: this.props.brdDet.id,
        favList: this.props.favList
      })
    };
    this.addItemToFav = this.addItemToFav.bind(this);
  }

  addItemToFav(itemId) {
    const pinStatusState = this.state.pinStatus;
    this.setState({
      pinStatus: pinStatusState === 1 ? 0 : 1
    });
    return pinUnpinUserFav(
      $(`fullBoardStFavImg_${this.props.brdDet.id}`),
      pinStatusState,
      itemId,
      this.props.menuType,
      this.props.brdDet.name
    );
  }

  render() {
    const wsName = this.props.brdDet.name ? this.props.brdDet.name : "";
    const tName = this.props.brdDet.tname ? this.props.brdDet.tname : "";
    const oName = this.props.brdDet.oname ? this.props.brdDet.oname : "";
    const imgId = this.state.pinStatus == 1 ? "delFromFav" : "addToFav";
    return (
      <div
        className="fullBoardSmallTileWrapper"
        key={`indtile${Math.random()}`}
        onClick={event =>
          loadBoardDetails(event, {
            id: this.props.brdDet.id,
            menuType: this.props.menuType,
            navigate: this.props.navigate,
          })
        }
      >
        {
          <div className={`fullBoardSmallTileDiv ${this.state.clsName}`}>
            <div
              className="fullBoardStImgWrapper"
              style={{ background: this.state.bgVal }}
            >
              &nbsp;
            </div>
            <div className="fullBoardStTextWrapper">
              <div className="fullBoardStNameWrapper truncate3" title={wsName}>
                {wsName}
              </div>
              <div
                className="fullBoardStOwnerWrapper truncateText"
                title={oName}
              >
                {oName}
              </div>
            </div>
            <div
              className={`fullBoardStFavImg fullBoardStFavImg_${this.props.brdDet.id}`}
              onClick={() => this.addItemToFav(this.props.brdDet.id)}
            >
              <ImgIconComp
                id={imgId}
                class="fullBoardFavImg"
                width="18"
                height="18"
              />
            </div>
          </div>
        }
      </div>
    );
  }
}

class FullBoardFavTile extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let randImg = "";
    if (this.props.brdDet.theme) {
      if (this.props.brdDet.theme.themeColor) {
        randImg = this.props.brdDet.theme.themeColor;
      } else if (this.props.brdDet.theme.themeImg) {
        randImg = `url(${this.props.brdDet.theme.themeImg})`;
      }
    }
    if (randImg.length == 0) {
      randImg = `url(${IconPathComp(
        FullBoardConst.IMG_ARR[
          Math.floor(Math.random() * FullBoardConst.IMG_ARR.length)
        ]
      )})`;
    }
    return (
      <div
        className="fullBoardTileWrapper"
        style={{ background: randImg }}
        onClick={event =>
          loadBoardDetails(event, {
            id: this.props.brdDet.obj_id,
            menuType: this.props.menuType,
            navigate: this.props.navigate,
          })
        }
      >
        <div className="fullBoardTileTextWrapper">
          <div
            className="fullBoardNameWrapper truncate3"
            title={this.props.brdDet.name ? this.props.brdDet.name : undefined}
          >
            <span 
              dangerouslySetInnerHTML={{__html: WbEventHandlerMixins.unSafeHtml(this.props.brdDet.name)}}
            />
          </div>
          <div
            className="fullBoardTeamWrapper truncateText"
            title={
              this.props.brdDet.teamName
                ? this.props.brdDet.teamName
                : undefined
            }
          >
            {this.props.brdDet.teamName}
          </div>
          <div
            className="fullBoardOwnerWrapper truncateText"
            title={
              this.props.brdDet.ownerName
                ? this.props.brdDet.ownerName
                : undefined
            }
          >
            {this.props.brdDet.ownerName}
          </div>
        </div>
      </div>
    );
  }
}

const getItemPinStatus = props => {
  let pinstatus = 0;
  if (props.favList && props.favList.length > 0) {
    const findItem = props.favList.find(item => item.obj_id === props.id);
    if (findItem) {
      pinstatus = 1;
    }
  }
  return pinstatus;
};

const getBgForTile = props => {
  let bgVal = "";
  if (props.theme) {
    if (props.theme.themeColor) {
      bgVal = props.theme.themeColor;
    } else if (props.theme.themeImg) {
      bgVal = `url(${props.theme.themeImg})`;
    }
  }
  if (bgVal.length == 0) {
    bgVal =
      FullBoardConst.BG_ARR[
        Math.floor(Math.random() * FullBoardConst.BG_ARR.length)
      ];
  }
  return bgVal;
};

const loadBoardDetails = (event, props) => {
  if ($('.fullBoardFavImg').is(event.target)) {
    return;
  }

  if (props.menuType === 'board') {
    // Navigate to board
    props.navigate(`/wb/board/index?id=${props.id}`);
  } else {
    // Navigate to workstream
    props.navigate(`/wb/activity/workstreams?id=${props.id}`);
  }
};

function mapStateToProps(state){
  return state;
}

export default connect(mapStateToProps)(hot(withTranslation()(WsFullBoardComp)));
